import React, { useState, useRef, useEffect } from 'react';
import { Form, Select, DatePicker, Divider, Radio } from 'antd';
import { PLATFORM_TYPE } from './data';
import './index.less';
import { InfoCircleOutlined } from '@ant-design/icons';
import CoreIndicators from './components/core-indicators';
import TrendAnalysis from './components/trend-analysis';
import ActivityDetailTable from '../activity-detail-table';
import CommodityDetailsTable from '../commodity-details-table';
import moment from 'moment';
import TimestampRangePicker from '@/components/timestamp-RangePicker';
import UserAnalysis from '../user-analysis';
const { RangePicker } = DatePicker;

const ActiveStage = (props) => {
  const [dates, setDates] = useState(null);
  const [hackValue, setHackValue] = useState(null);
  const [position, setPosition] = useState('1');
  // const [value, setValue] = useState(null);
  const [tag, setTag] = useState(props.activityStatus === '1' ? 2 : 1);
  const defaultTime =
    props.activityStatus === '1'
      ? moment(props.activityEndTime).format('YYYY-MM-DD')
      : moment().subtract(1, 'days').format('YYYY-MM-DD');

  const [value, setValue] = useState([moment(defaultTime), moment(defaultTime)]);
  const [param, setParam] = useState({
    platformCd: '全部',
    realTimeData: props.activityStatus !== '1',
    dt: moment(defaultTime).format('YYYY-MM-DD'),
    startTime: defaultTime,
    endTime: defaultTime,
  });

  function disabledDate(current) {
    // return current < moment(props.activityStartTime) || current > moment(props.activityEndTime);

    if (!dates) {
      return (
        current < moment(props.activityStartTime).startOf('day') || current > moment(props.activityEndTime).endOf('day')
      );
    } else {
      const tooLate = dates[0] && current.diff(dates[0], 'days') > 30;
      const tooEarly = dates[1] && dates[1].diff(current, 'days') > 30;
      return !!tooEarly || !!tooLate || current > moment(props.activityEndTime);
    }
  }

  const onOpenChange = (open) => {
    if (open) {
      setHackValue([null, null]);
      setDates(null);
    } else {
      setHackValue(null);
    }
  };

  return (
    <>
      <div className="participant-data-stage-card-bg">
        <div className="stage-header-clear-fix">
          <div style={{ display: 'flex', marginBottom: '-24px', height: '60px' }}>
            <Form.Item label="平台" style={{ width: '186px', marginRight: '17px' }}>
              <Select
                allowClear={true}
                placeholder="请选择"
                onChange={(val) => {
                  if (val) {
                    setParam({ ...param, platformCd: val });
                  } else {
                    setParam({ ...param, platformCd: '全部' });
                  }
                }}
              >
                {PLATFORM_TYPE.map((item, index) => (
                  <Select.Option key={index} value={item.val}>
                    {item.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item>
              <a
                disabled={props.activityStatus === '1'}
                className={'active-stage-time' + (tag === 1 ? ' select' : '')}
                onClick={() => {
                  if (props.activityStatus === '1') return;
                  setParam({ ...param, realTimeData: true });
                  setTag(1);
                }}
              >
                实时
              </a>
            </Form.Item>
            <Form.Item>
              <Divider type="vertical" style={{ margin: '0' }} />
            </Form.Item>
            <Form.Item>
              <a
                disabled={
                  moment(Date.now()).format('YYYY-MM-DD') === moment(props.activityStartTime).format('YYYY-MM-DD')
                }
                className={'active-stage-time' + (tag === 2 ? ' select' : '')}
                onClick={() => {
                  if (moment(Date.now()).format('YYYY-MM-DD') === moment(props.activityStartTime).format('YYYY-MM-DD'))
                    return;
                  setParam({ ...param, realTimeData: false });
                  setTag(2);
                }}
              >
                离线
              </a>
            </Form.Item>
            <Form.Item>
              <RangePicker
                disabled={tag === 1}
                value={hackValue || value}
                disabledDate={disabledDate}
                allowClear={false}
                onCalendarChange={(val) => setDates(val)}
                // onChange={(val) => setValue(val)}
                onOpenChange={onOpenChange}
                onChange={(data, str) => {
                  console.log('选择的日期', data, str);
                  setValue(data);
                  setParam({ ...param, startTime: str[0], endTime: str[1] });
                }}
              />
              <InfoCircleOutlined style={{ marginLeft: '14px', color: '#FEB00E' }} width={12} height={12} />
              <span style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)', marginLeft: '3px', lineHeight: '22px' }}>
                实时数据每日整点更新
              </span>
            </Form.Item>
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
              <div style={{ marginRight: '60px' }}>
                <div
                  className={'participant-data-radio-tab' + (position === '1' ? ' select' : '')}
                  onClick={() => {
                    setPosition('1');
                  }}
                >
                  活动概览
                </div>
                <div className={'participant-data-radio-line' + (position === '1' ? ' select' : '')} />
              </div>
              <div style={{ marginRight: '60px' }}>
                <div
                  className={'participant-data-radio-tab' + (position === '2' ? ' select' : '')}
                  onClick={() => {
                    setPosition('2');
                  }}
                >
                  会场明细
                </div>
                <div className={'participant-data-radio-line' + (position === '2' ? ' select' : '')} />
              </div>
              <div style={{ marginRight: '60px' }}>
                <div
                  className={'participant-data-radio-tab' + (position === '3' ? ' select' : '')}
                  onClick={() => {
                    setPosition('3');
                  }}
                >
                  商品明细
                </div>
                <div className={'participant-data-radio-line' + (position === '3' ? ' select' : '')} />
              </div>
              <div style={{ marginRight: '60px' }}>
                <div
                  className={'participant-data-radio-tab' + (position === '4' ? ' select' : '')}
                  onClick={() => {
                    setPosition('4');
                  }}
                >
                  用户分析
                </div>
                <div className={'participant-data-radio-line' + (position === '4' ? ' select' : '')} />
              </div>
            </div>
          </div>
        </div>
        {position === '1' && (
          <>
            <CoreIndicators
              title="核心指标"
              period="0"
              planCode={props.planCode}
              startTime={param.startTime}
              endTime={param.endTime}
              realTimeData={param.realTimeData}
              platformCd={param.platformCd}
            />
            <TrendAnalysis
              startTime={param.startTime}
              endTime={param.endTime}
              realTimeData={param.realTimeData}
              planCode={props.planCode}
              platform={param.platformCd}
            />
          </>
        )}
        {position === '2' && (
          <ActivityDetailTable
            planCode={props.planCode}
            realTimeData={param.realTimeData}
            startTime={param.startTime}
            endTime={param.endTime}
            statisticsDimension="0"
            platform={param.platformCd}
            dt={param.dt}
          />
        )}
        {position === '3' && (
          <CommodityDetailsTable
            planCode={props.planCode}
            realTimeData={param.realTimeData}
            startTime={param.startTime}
            endTime={param.endTime}
            statisticsDimension="0"
            platform={param.platformCd}
            dt={param.dt}
          />
        )}
        {position === '4' && (
          <UserAnalysis
            realTimeData={param.realTimeData}
            planCode={props.planCode}
            platformCd={param.platformCd}
            startTime={param.startTime}
            endTime={param.endTime}
          />
        )}
      </div>
    </>
  );
};
export default ActiveStage;
